module.exports = __webpack_public_path__ + "img/27807598000343.fb7e6e92.png";